<template>
    <div class="left-sidebar bg-white p-3 rounded" style="border: 1px solid #f4f4f4;">
        <div class="sidebar-search mb-4">
            <input type="text" class="form-control" placeholder="Buscar en esta colección..." style="font-size: 0.85rem; padding: 10px 15px; border-radius: 8px; border: 1px solid #e1e1e1;">
        </div>

        <div class="panel-group category-products mt-4">
            <h6 class="mb-3" style="font-size: 0.75rem; font-weight: 800; letter-spacing: 1px; color: #000;">CATEGORÍAS</h6>
            <div class="menu-categorias mb-4" v-if="categories" :key="1">
                <fade-transition group>
                    <menu-item class="tree-view-root" v-for="node in categories" :key="node.id" :id="node.id" :label="node.nombre" :nodes="node.sublevels" :depth="0"></menu-item>
                </fade-transition>
            </div>
            
            <div class="filter p-0 tree-view-root" :key="2"></div>
        </div>
        
        <div class="panel-group mt-4">
            <h6 class="mb-3" style="font-size: 0.75rem; font-weight: 800; letter-spacing: 1px; color: #000;">ETIQUETAS GLOABALES</h6>
            <div class="filter">
                <div class="custom-control custom-checkbox mb-2">
                    <input type="radio" id="tagTodas" value="" v-model="selectedTag" @change="cambiarFiltroEtiqueta" class="custom-control-input">
                    <label class="custom-control-label text-dark" for="tagTodas" style="font-size: 0.85rem;">Todas</label>
                </div>
                <div v-for="tag in uniqueTags" :key="tag" class="custom-control custom-checkbox mb-2">
                    <input type="radio" :id="'tag_'+tag" :value="tag" v-model="selectedTag" @change="cambiarFiltroEtiqueta" class="custom-control-input">
                    <label class="custom-control-label text-dark" :for="'tag_'+tag" style="font-size: 0.85rem;">{{ tag }}</label>
                </div>
            </div>
        </div>

        <!-- Simulated Availability and Price matching the image -->
        <div class="panel-group mt-4">
            <h6 class="mb-3" style="font-size: 0.75rem; font-weight: 800; letter-spacing: 1px; color: #000;">DISPONIBILIDAD</h6>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" id="disp1" class="custom-control-input" checked>
                <label class="custom-control-label text-dark" for="disp1" style="font-size: 0.85rem;">En existencia ({{products? (products.data ? products.data.length : products.length) : 0}})</label>
            </div>
        </div>

    </div>
</template>

<script>
    import {
        FadeTransition
    } from 'vue2-transitions'
    import MenuItem from './MenuItem.vue'
    import Filters from './Filters.vue'
    import {
        mapState
    } from 'vuex';
    export default {
        name: 'emenu',
        components: {
            MenuItem,
            Filters,
            FadeTransition
        },
        data() {
            return {
                showFilter: true,
                selectedTag: ''
            }
        },
        computed: {
            ...mapState(['categories', 'products', 'filterTag']),
            uniqueTags() {
                let tags = new Set();
                let productList = this.products.data || this.products || [];
                productList.forEach(p => {
                    if (p.etiquetas) {
                        p.etiquetas.split(',').forEach(tag => tags.add(tag.trim()));
                    }
                });
                return Array.from(tags).filter(t => t.length > 0);
            }
        },
        watch: {
            filterTag(newVal) {
                this.selectedTag = newVal || '';
            }
        },
        methods: {
            cambiarFiltroEtiqueta() {
                this.$store.commit('updateFilterTag', this.selectedTag);
            }
        }
    }
</script>

<style>
</style>